/** A currency someone actually chose or the server returned; blank is not a currency. */
export function isCurrencyStated(code: string | null | undefined): code is string {
  return typeof code === 'string' && code.trim().length > 0;
}

/** The chosen currency for a request, or undefined so the parameter is left off. */
export function statedCurrencyOrOmitted(code: string | null | undefined): string | undefined {
  return isCurrencyStated(code) ? code.trim() : undefined;
}
